var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-carousel"},[_c('c-carousel',_vm._b({},'c-carousel',_vm.carouselOptions,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }